import copy from 'copy-to-clipboard';
import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/carousel';

import {CompanyProfilePublicCarousel} from './company-profile-public-carousel'

export class CompanyProfilePublic {
    readonly alertContainerId = 'company-profile-public-share-alert';
    readonly copiedLabelDelay = 5000;
    readonly copyPublicProfileUrlButtonId = 'copy-public-profile-url';
    readonly badgeId = 'company-profile-badge';
    readonly badgePopoverId = 'badge-popover';
    readonly anonymousIconsClass = 'js-anonymous-review-question-icon';

    private alertElement: HTMLElement;
    private badgePopover: JQuery<HTMLElement>;
    private badgePopoverOpened = false;
    private badgePopoverTemplate: HTMLElement;


    public init() {
        this.activateBadgePopover(`#${this.badgeId}`);
        this.activateAnonymousPopovers();
    }

    public dismissNotice(): void {
        CompanyProfilePublic.hideNoticeBlock(this.getNoticeBlock());
    }

    public copyUrl(url: string): void {
        copy(url, {
            debug: true,
            format: 'text/plain',
            onCopy: () => {
                this.showSuccessNotice();
                this.changeCopyButtonState();
            }
        });
    }

    private activateBadgePopover(selector: string) {
        this.badgePopover = $(selector);
        this.badgePopover.popover();
        this.subscribeToPopoverEvents();
    }

    private showSuccessNotice(): void {
        CompanyProfilePublic.showNoticeBlock(this.getNoticeBlock());
    }

    private getNoticeBlock(): HTMLElement | undefined {
        if (!this.alertElement) {
            this.alertElement = document.querySelector(`#${this.alertContainerId}`);
        }
        return this.alertElement;
    }

    private static hideNoticeBlock(element: HTMLElement): void {
        element.classList.remove('d-block');
        element.classList.add('d-none');
    }

    private static showNoticeBlock(element: HTMLElement): void {
        element.classList.remove('d-none');
        element.classList.add('d-block');
    }

    private subscribeToPopoverEvents() {
        this.handleBadgeClickEvent();
        this.handleOutsideClickEvent();
        this.handlePopoverCloseEvents();
        this.handlePopoverOpenEvents();
    }

    private handleBadgeClickEvent(): void {
        this.badgePopover.on('click', () => {
            this.badgePopover.popover('toggle');
        })
    }

    private handleOutsideClickEvent(): void {
        document.addEventListener('click', (event: any) => {
            if (this.badgePopoverTemplate && !$.contains(this.badgePopoverTemplate, event.target) && this.badgePopoverOpened) {
                this.hideBadgePopover();
            }
        });
    }

    private hideBadgePopover(): void {
        this.badgePopover.popover('hide');
    }

    private handlePopoverOpenEvents(): void {
        // fired when show popover function triggered
        this.badgePopover.on('show.bs.popover', () => {
            this.badgePopover.addClass('active');
        });

        // fired when popover fully shown
        this.badgePopover.on('shown.bs.popover', () => {
            this.badgePopoverOpened = true;
            this.badgePopoverTemplate = document.querySelector(`#${this.badgePopoverId}`);
        });
    }

    private handlePopoverCloseEvents(): void {
        // fired when hide popover function triggered
        this.badgePopover.on('hide.bs.popover', () => {
            this.badgePopover.removeClass('active');
        });
        // fired when popover fully hidden
        this.badgePopover.on('hidden.bs.popover', () => {
            this.badgePopoverOpened = false;
            this.badgePopoverTemplate = null;
        });
    }

    private changeCopyButtonState() {
        const button = document.querySelector(`#${this.copyPublicProfileUrlButtonId}`) as HTMLButtonElement;
        button.classList.add('copied');
        button.disabled = true;
        setTimeout(() => {
            button.classList.remove('copied');
            button.disabled = false;
        }, this.copiedLabelDelay);
    }

    readonly loadMoreContainerSelector = '.js-load-more-container';
    readonly loadMoreListSelector = '.js-load-more-list';
    readonly loadMoreButtonSelector = '.js-load-more-button';

    public loadMore(element: HTMLElement) {
        let container = $(element).closest(this.loadMoreContainerSelector);
        let list = container.find(this.loadMoreListSelector);
        let button = container.find(this.loadMoreButtonSelector);
        void $.get(button.data('url'))
            .done((response) => {
                list.append(response.html);
                this.activateAnonymousPopovers();
                if (response.nextPage) {
                    button.data('url', response.nextPage);
                } else {
                    button.hide();
                }
            });
    }

    private activateAnonymousPopovers(): void {
        $('.' + this.anonymousIconsClass).popover();
    }
}

const companyProfilePublic = new CompanyProfilePublic();
const companyProfilePublicCarousel = new CompanyProfilePublicCarousel();
window.addEventListener('load', () => {
    companyProfilePublic.init();
    companyProfilePublicCarousel.init();
});

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.companyProfilePublic = companyProfilePublic;
(<any>window).skyComponents.companyProfilePublicCarousel = companyProfilePublicCarousel;
